import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Contact = () => {
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3000);
    };

    return (
        <section className="container">
            {/* Breadcrumb Navigation */}
            <nav aria-label="breadcrumb" className="mt-4 mb-4">
                <ol className="breadcrumb">
                    {/* Home Link */}
                    <li className="breadcrumb-item">
                        <Link to="/" className="text-dark text-decoration-none">
                            <i className="fas fa-home me-2"></i> Home
                        </Link>
                    </li>
                    <li className="breadcrumb-item">
                        <i className="fa-regular fa-folder me-2"></i> Contact Us
                    </li>
                </ol>
            </nav>


            {/* Bootstrap Alert */}
            {showAlert && (
                <div className="alert alert-success alert-dismissible fade show" role="alert">
                    Your message has been sent successfully!
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => setShowAlert(false)}
                    ></button>
                </div>
            )}

            <div className="row mt-5">
                {/* Left Side - Contact Form */}
                <div className="col-md-7 mb-5">
                    <form className="row g-3" onSubmit={handleSubmit}>
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">First Name *</label>
                            <input type="text" className="form-control" placeholder="First Name" required />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">Last Name *</label>
                            <input type="text" className="form-control" placeholder="Last Name" required />
                        </div>

                        <div className="col-12">
                            <label className="form-label fw-semibold">Email *</label>
                            <input type="email" className="form-control" placeholder="Email Address" required />
                        </div>

                        <div className="col-12">
                            <label className="form-label fw-semibold">Subject</label>
                            <input type="text" className="form-control" placeholder="Subject" />
                        </div>

                        <div className="col-12">
                            <label className="form-label fw-semibold">Your Message *</label>
                            <textarea className="form-control" rows="5" placeholder="Your Message" required></textarea>
                        </div>

                        <div className="col-12">
                            <button type="submit" className="btn btn-dark px-4">
                                Send Message
                            </button>
                        </div>
                    </form>
                </div>
                {/* right Side - Contact Info */}
                <div className="col-md-5 px-5">
                    <h2 className="fw-bold text-dark mb-4 ">GET IN TOUCH</h2>
                    <div className="d-flex align-items-start mb-4">
                        <div className="bg-dark text-warning rounded p-3 me-3">
                            <i className="fa-solid fa-location-dot fa-lg"></i>
                        </div>
                        <div>
                            <h5 className="fw-semibold mb-1">Address</h5>
                            <p className="mb-0">2120 Camino Doce SW, Deming, New Mexico 88030, USA</p>
                        </div>
                    </div>

                    <div className="d-flex align-items-start mb-4">
                        <div className="bg-dark text-warning rounded p-3 me-3">
                            <i className="fa-solid fa-phone fa-lg"></i>
                        </div>
                        <div>
                            <h5 className="fw-semibold mb-1">Phone</h5>
                            <p className="mb-0">+1 (574) 858-0288</p>
                        </div>
                    </div>

                    <div className="d-flex align-items-start mb-4">
                        <div className="bg-dark text-warning rounded p-3 me-3">
                            <i className="fa-solid fa-envelope fa-lg"></i>
                        </div>
                        <div>
                            <h5 className="fw-semibold mb-1">Email</h5>
                            <p className="mb-0">contact@onlineshopmatrix.com</p>
                        </div>
                    </div>
                    <div className="mb-4">
                        <div>
                            {/* <iframe
                                src="https://www.google.com/maps?q=2120+Camino+Doce+SW,+Deming,+New+Mexico+88030,+USA&output=embed"
                                className="rounded"
                                title="Online Shop Matrix Location"
                                allowFullScreen
                                loading="lazy"
                                style={{height:'170px',width:'400px'}}
                            ></iframe> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
